import { AuthEnums } from "models/enums";
import { ApiClientInstance } from "utils/helpers";
import { WintSuperkollAPIModelExportItems } from "wint-api-client/dist/types";

/**
 * @deprecated This service is deprecated. Use useExportItemsService hook instead.
 *
 * @see useExportItemsService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const ExportItemsService = {
  queueExport: (entityId: number, type: WintSuperkollAPIModelExportItems.ExportItemType, showErrors?: boolean) => {
    const exportItemPost: WintSuperkollAPIModelExportItems.ExportItemPost = {
      entityId: entityId,
      type: type,
    };

    return ApiClientInstance(AuthEnums.AuthType.Company, {
      showErrors: showErrors ?? true,
      responseType: "arraybuffer",
    }).ExportItemsClient.Post(exportItemPost);
  },
};

export default ExportItemsService;
